export default __webpack_public_path__ + "static/media/480_portfolio02-en-mobile.c0913b1f.png";